import { render, staticRenderFns } from "./my_info.vue?vue&type=template&id=74e5e921&"
import script from "./my_info.vue?vue&type=script&lang=js&"
export * from "./my_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports